import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { HeadingText } from '@paypalcorp/pp-react';
import OptimizedImage from './OptimizedImage';
import { parseData } from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

import { AMPLITUDE } from '../../../lib/constants';

const { MAIN_COLLECTION_TOOL_TILE_CLICK } = AMPLITUDE;

const CollectionToolTile = props => {
  const { fptiClick, fptiImpression } = props;
  const {
    featureImage,
    title,
    subtitle,
    fptiLinkName,
    location: to,
    fptiCategoryName
  } = props.collection;
  const location = useLocation();

  const image = parseData(featureImage)[0];
  const backgroundColor = image?.backgroundColor;
  const imageUrl = image?.url;
  const isImageBottomAligned = image?.isBottomAligned === 'TRUE';
  const isBackgroundImage = image?.isBackgroundImage === 'TRUE';
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: fptiLinkName,
      category: 'parent'
    });
  });

  const handleClick = fptiLink => {
    fptiClick({
      fptiLink: (typeof fptiLink === 'string' && fptiLink) || fptiLinkName,
      category: 'parent',
      pageLink: fptiLinkName,
      amplitude: true,
      event_name: MAIN_COLLECTION_TOOL_TILE_CLICK,
      type: fptiCategoryName
    });
  };

  const renderImage = () => {
    const newStyle = {
      background: backgroundColor,
      backgroundImage: `url(${imageUrl})`,
      backgroundRepeat: 'repeat-x'
    };

    if (isBackgroundImage) {
      return <div className="collection-tool-media" style={newStyle} />;
    }

    return (
      <div
        className="collection-tool-media"
        style={{ background: backgroundColor }}
      >
        <div
          className={
            isImageBottomAligned
              ? 'collection-tool-wrapper bottom-aligned'
              : 'collection-tool-wrapper'
          }
        >
          <OptimizedImage
            imageUrl={imageUrl}
            className={'collection-tool-image'}
            disableOptimization
          />
        </div>
      </div>
    );
  };

  return (
    <Link
      className="collection-tool-tile undo-link-styles add-focus-visible"
      to={{
        pathname: `/businesstools/collection/${to}`,
        state: { prevPath: location.pathname }
      }}
      onClick={handleClick}
    >
      <div className="collection-tool-inner" ref={ref}>
        {renderImage()}
        <div className="collection-tool-item-text">
          <div className="collection-tool-item-header">
            <HeadingText level={2} className={'collection-tool-item-heading'}>
              {title}
            </HeadingText>
          </div>
          <h4 className="collection-tool-item-subheading">{subtitle}</h4>
        </div>
      </div>
    </Link>
  );
};

CollectionToolTile.propTypes = {
  collection: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func
};

export default CollectionToolTile;
